var maxPercentage = 100;
export var getColorStyles = function (colorValue) {
    var style = { background: '' };
    var colors = colorValue.split('|');
    if (colors.length === 0) {
        return style;
    }
    var percents = 0;
    var delta = Math.floor(maxPercentage / colors.length);
    style.background =
        colors.reduce(function (accumulator, color) {
            return accumulator + ", #" + color + " " + percents + "%, #" + color + " " + (percents += delta) + "%";
        }, 'linear-gradient(45deg') + ')';
    return style;
};
